<div class="container-fluid" id="container-wrapper" style="background-color: white;padding: 5px;" *ngIf="userType=='Admin' || userType=='Counsellor'">

    <div class="d-sm-flex align-items-center justify-content-between mb-4" style="border-bottom:2px solid grey;">
        <h1 class="h3 mb-0 text-gray-800">Failed Follow-Ups</h1>
        <div style="display: flex; align-items: center; gap: 10px;">
            <li class="nav-item dropdown no-arrow mx-1" style="list-style: none;">
                <a (click)="openFilterForm()" style="cursor: pointer;top: 10px;">
                    <i class="fa fa-filter fa-lg text-danger pull-right" aria-hidden="true" style="margin-top: 5px;"></i>
                </a>
            </li>
            <button mat-icon-button matTooltip="Search" [matMenuTriggerFor]="search">
                <mat-icon [ngStyle]="{'color':'#27682'}">search</mat-icon>
            </button>
            <mat-menu #search [overlapTrigger]="false" yPosition="below" style=" padding-top: 0px !important; padding-bottom: 0px !important; line-height:35px; height:35px;">
                <form (click)="stopPropagation($event)" style="min-height: 40px;">
                    <input id='myInput' (keyup)='searchTable()' type='text' style="width:200px;height: 20px;">
                </form>
                <p style="padding-left: 10px;">Enter Any Text To Search</p>
            </mat-menu>
        </div>
    </div>








    <div class="row" style="margin-top: 0px;">
        <div style="display: inline-flex;overflow-y: hidden;overflow-x: scroll;white-space: nowrap;width: 100%;float: inline-end;margin-top: 5px;position: absolute;">
            <a *ngFor="let mnu of statusWiseLeads" class="btn btn-info text-white" style="margin-right: 3px!important;" (click)="getLeadsByStatus(mnu.name)">
            {{mnu.name}}( {{mnu.value}} )
            </a>
        </div>
    </div>

    <table class="table table-sm" style="padding-right: 20px!important;margin-top: 40px;position: absolute;font-size: small;">
        <tr class="thead-dark">
            <th>#</th>
            <th>Student Details</th>
            <th *ngIf="!androidOs">Address</th>
            <th>Lead Status</th>
            <th *ngIf="!androidOs">Other Details</th>
            <th style="max-width: 35px;">Action</th>
        </tr>
        <tbody id="myTable">
            <tr *ngFor="let item of pagedItems;let counter=index;">
                <td>{{counter+1}}</td>
                <td><b>Name : </b>{{item.studentName}}<br><b>Mobile : </b>{{item.mobileNo}}
                    <a (click)="phoneClick(item.refNo,item.studentName,item.mobileNo,item.status)"><img src="../../assets/img/phone-calls.png" style="width: 20px;height: 20px;"></a>

                    <br><b>E-Mail : </b>{{item.emailId}}</td>
                <td *ngIf="!androidOs"><b>Address : </b>{{item.address}}<br><b>City : </b> {{item.cityName}}<br><b>State : </b> {{item.stateName}}</td>
                <td><b>Status : </b>{{item.status}}<br><b>Sub-Status : </b>{{item.subStatus}}<br><b>Lead Date : </b>{{item.leadDate}}</td>
                <td *ngIf="!androidOs"><b>Follow-Up Status: </b>{{item.followUpStatus}}<br><b>Next Follow-Up Date : </b> {{item.nextFolloupDate| date: 'dd-MM-yyyy'}}<br><b>Last Note : </b> {{item.followUpsNote}}</td>
                <th style="max-width: 20px!important;">
                    <li class="nav-item dropdown no-arrow mx-1" style="cursor: pointer;">
                        <a class="nav-link " id="alertsDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                        </a>
                        <div class="dropdown-menu dropdown-menu-right shadow " aria-labelledby="alertsDropdown">
                            <!-- <a class="dropdown-item d-flex align-items-center" (click)="editLeadsClicked(item.refNo,true)">
                            <div class="mr-3">
                                <div class="icon-circle">
                                    <img src="./../../../assets/img/edit.png" style="width: 30px;height:25px;padding-right: 10px;">
                                </div>
                            </div>
                            <div>
                                Edit
                            </div>
                        </a> -->
                            <!-- <a class="dropdown-item d-flex align-items-center" (click)="sidePanel(item.refNo,true)">
                            <div class="mr-3">
                                <div class="icon-circle">
                                    <img src="./../../../assets/img/chatting.png" style="width: 30px;height:25px;padding-right: 10px;">
                                </div>
                            </div>
                            <div>
                                Start Chat
                            </div>
                        </a> -->
                            <a class="dropdown-item d-flex align-items-center" (click)="openNotesForm(item.refNo,item.studentName,item.status)">
                                <div class="mr-3">
                                    <div class="icon-circle">
                                        <img src="./../../../assets/img/project.png" style="width: 30px;height:25px;padding-right: 10px;">
                                    </div>
                                </div>
                                <div>
                                    Follow-Up Notes
                                </div>
                            </a>
                            <!-- <a class="dropdown-item d-flex align-items-center" (click)="assignToOtherCounsellor(item.refNo,item.studentName)">
                            <div class="mr-3">
                                <div class="icon-circle">
                                    <img src="./../../../assets/img/assign.png" style="width: 30px;height:25px;padding-right: 10px;">
                                </div>
                            </div>
                            <div>
                                Assign to Other
                            </div>
                        </a> -->
                            <a class="dropdown-item d-flex align-items-center" (click)="viewLeadWiseActivityLog(item.refNo,item.studentName)">
                                <div class="mr-3">
                                    <div class="icon-circle">
                                        <img src="./../../../assets/img/followup.png" style="width: 30px;height:25px;padding-right: 10px;">
                                    </div>
                                </div>
                                <div>
                                    View Follow-Ups
                                </div>
                            </a>
                        </div>
                    </li>
                </th>
            </tr>
        </tbody>
        <!-- <tr>
            <th colspan="4" *ngIf="(leads | async)?.length==0">No data found !</th>
        </tr> -->
    </table>
    <div class="pagination-wrapper">
        <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
            <li [ngClass]="{disabled:pager.currentPage === 1}">
                <a (click)="setPage(1)">First</a>
            </li>
            <li [ngClass]="{disabled:pager.currentPage === 1}">
                <a (click)="setPage(pager.currentPage - 1)">Prev</a>
            </li>
            <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                <a (click)="setPage(page)">{{page}}</a>
            </li>
            <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                <a (click)="setPage(pager.currentPage + 1)">Next</a>
            </li>
            <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                <a (click)="setPage(pager.totalPages)">Last</a>
            </li>
        </ul>
    </div>

</div>

<!-- FILTER FORM-->
<div id="myFilterForm" class="form-popup-popup" style="z-index: 999;">
    <div class="card-header d-flex flex-row align-items-center justify-content-between" style="background-color: rgb(1, 9, 15);">
        <h6 class="font-weight-bold " style="color: white;">Lead Filter</h6>
        <button type="button" class="btn btn-danger" style="float: right;" (click)="closeFilterForm()">X</button>
    </div>
    <div class="card-body" style="height: 250px!important;overflow-y: scroll;background-color: rgb(160, 170, 170);">

        <div class="form-group row" style="margin-bottom: -5px;">
            <mat-form-field class="col-sm-6">
                <input matInput type="date" name="fromDate" [(ngModel)]="leadFilter.fromDate" placeholder="From Date" [min]="fromDate">
            </mat-form-field>
            <mat-form-field class="col-sm-6">
                <input matInput type="date" name="toDate" [(ngModel)]="leadFilter.toDate" placeholder="To Date" [min]="fromDate">
            </mat-form-field>
        </div>
        <div class="form-group row" style="margin-bottom: -5px;">
            <mat-form-field class="col-sm-6">
                <mat-select class="field-full-width" placeholder="Lead Status" [(ngModel)]="leadFilter.status">
                    <mat-option value="All">All</mat-option>
                    <mat-option *ngFor="let stat of listStatus" [value]="stat">{{stat}}</mat-option>
                </mat-select>

            </mat-form-field>
            <mat-form-field class="col-sm-6">

                <mat-select class="field-full-width" placeholder="Lead Sub-Status" [(ngModel)]="leadFilter.subStatus">
                    <mat-option value="All">All</mat-option>
                    <mat-option *ngFor="let stat of listSubStatus" [value]="stat">{{stat}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="form-group row" style="margin-bottom: -5px;">
            <mat-form-field class="col-sm-6">
                <mat-select class="field-full-width" placeholder="State" [(ngModel)]="leadFilter.state">
                    <mat-option value="All">All</mat-option>
                    <mat-option *ngFor="let stat of listState" [value]="stat">{{stat}}</mat-option>
                </mat-select>

            </mat-form-field>
            <mat-form-field class="col-sm-6">
                <mat-select class="field-full-width" placeholder="City" [(ngModel)]="leadFilter.city">
                    <mat-option value="All">All</mat-option>
                    <mat-option *ngFor="let stat of listCity" [value]="stat">{{stat}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="form-group row" style="margin-bottom: -5px;">
            <mat-form-field class="col-sm-6">
                <mat-select class="field-full-width" placeholder="Counsellor" [(ngModel)]="leadFilter.assignedTo">
                    <mat-option value="All">All</mat-option>
                    <mat-option *ngFor="let stat of listCounsellor" [value]="stat">{{stat}}</mat-option>
                </mat-select>

            </mat-form-field>
            <mat-form-field class="col-sm-6">
                <mat-select class="field-full-width" placeholder="Source" [(ngModel)]="leadFilter.leadSource">
                    <mat-option value="All">All</mat-option>
                    <mat-option *ngFor="let stat of listSource" [value]="stat">{{stat}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

    </div>

    <div class="card-footer" style="background-color: rgb(1, 9, 15);">
        <button type="button" class="btn btn-primary block" (click)="filterLeads();closeFilterForm();">Apply</button>
    </div>
</div>





<!-- NOTES FORM-->

<div id="myNotesForm" class="form-popup-popup" style="z-index: 999;">
    <div class="card-header d-flex flex-row align-items-center justify-content-between" style="background-color: rgb(1, 9, 15);">
        <h6 class="font-weight-bold " style="color: white;">Follow-Up Note</h6>
        <button type="button" class="btn btn-danger" style="float: right;" (click)="closeNotesForm()">X</button>
    </div>
    <div class="card-body" style="height: 350px!important;overflow-y: scroll;background-color: rgb(160, 170, 170);">


        <div class="form-group row" style="display: none;">
            <label class="col-sm-12" for="inputEmail3">Ref No</label>
            <div class="col-sm-12">
                <input type="text" class="form-control" name="studentId" [(ngModel)]="leadNotes.studentId">
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-6" for="name">Candidate Name</label>
            <label class="col-sm-6" for="name">Communication Date</label>
            <div class="col-sm-6" style="padding-bottom: -10px;">
                <input type="text" class="form-control" name="name" [(ngModel)]="leadNotes.name" readonly>
            </div>
            <div class="col-sm-6" style="padding-bottom: -10px;">
                <input type="date" readonly class="form-control" name="nextActionDate" [(ngModel)]="leadNotes.nextActionDate">
            </div>
        </div>
        <div class="form-group row">

            <label class="col-sm-6" for="inputEmail3">Follow-Up Date</label>
            <label class="col-sm-6" for="inputEmail3">Follow-Up Time</label>
            <div class="col-sm-6">
                <input type="date" class="form-control" name="nextActionDate" [(ngModel)]="leadNotes.nextActionDate">
            </div>
            <div class="col-sm-6">
                <input type="time" class="form-control" name="scheduleTime" [(ngModel)]="leadNotes.scheduleTime">
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-6" for="inputEmail3">Lead Activity</label>
            <label class="col-sm-6" for="inputEmail3">New Status</label>
            <div class="col-sm-6">
                <select name="action" class="form-control" [(ngModel)]="leadNotes.action">
                    <option value="Call" selected>Call</option>
                    <option value="SMS">SMS</option>
                    <option value="WhatsApp">WhatsApp</option>
                    <option value="E-Mail">E-Mail</option>
                </select>
            </div>
            <div class="col-sm-6">
                <select name="status" class="form-control" [(ngModel)]="leadNotes.status">
                    <option value="0" selected disabled>Select Current Status</option>
                    <option *ngFor="let item of leadStatus" value="{{item.statusName}}">{{item.statusName}}</option>
                </select>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-12" for="inputEmail3">Details</label>
            <div class="col-sm-12">
                <textarea rows="3" class="form-control" name="note" [(ngModel)]="leadNotes.note">
                    </textarea>
            </div>
        </div>

    </div>

    <div class="card-footer" style="scroll;background-color:rgb(1, 9, 15);">
        <button type="button" class="btn btn-primary block" (click)="saveNotes();">Save</button>
    </div>
</div>